import { RazorImageFallback } from "../../../components/razor-reuse";
import React from "react";
import { ALL_ICONS } from "../../../assets/icons/AllIcons";
import { removeEmptySpaces } from "../../../utils/Helper";
import "./CurrencyText.css";
import Skeleton from "react-loading-skeleton";

interface myComponentProps {
  currency?: string;
  text?: string;
  onClick?: (param: any) => void;
  className?: string;
  stopPropagation?: boolean;
  imgSize?: any;
  url?: string;
  loading?: boolean;
}

const CurrencyText = ({
  className,
  currency,
  onClick,
  text,
  url,
  stopPropagation,
  imgSize,
  loading,
}: myComponentProps) => {
  return (
    <div
      onClick={(e) => {
        stopPropagation && e.stopPropagation();
        onClick?.(text);
      }}
      className={`currency-text-smart-send-index-wrapper ${
        className ? className : ""
      }`}
      style={{ "--size-value": imgSize || "2rem" } as React.CSSProperties}
    >
      {/* cur u=img start */}
      <div className="icon-box">
        {loading ? (
          <>
            <Skeleton
              style={{ alignSelf: "center", marginTop: "-1rem" }}
              className="img-box"
              circle
              height={25}
              width={25}
            />
          </>
        ) : (
          <RazorImageFallback className="img-box" url={url}>
            <figure className="img-box">
              {removeEmptySpaces(currency?.toLocaleLowerCase() as any) === "ngn"
                ? ALL_ICONS?.ngn
                : removeEmptySpaces(currency?.toLocaleLowerCase() as any) ===
                  "eur"
                ? ALL_ICONS?.eur
                : removeEmptySpaces(currency?.toLocaleLowerCase() as any) ===
                  "gbp"
                ? ALL_ICONS?.gbp
                : removeEmptySpaces(currency?.toLocaleLowerCase() as any) ===
                  "cad"
                ? ALL_ICONS?.cad
                : removeEmptySpaces(currency?.toLocaleLowerCase() as any) ===
                  "usd"
                ? ALL_ICONS?.usd
                : ""}
            </figure>
          </RazorImageFallback>
        )}
      </div>
      {/* cur u=img end */}
      {/* text start */}
      {loading ? (
        <>
          <Skeleton
            style={{ marginTop: "1.5rem", marginLeft: "1rem" }}
            width={40}
            height={12}
          />
        </>
      ) : (
        <>
          {" "}
          <p className="text">{text || ""}</p>
        </>
      )}

      {/* text end */}
    </div>
  );
};

export default CurrencyText;
